<template>
	<div class="container">
		<div class="page page-settings">
			<!-- Header -->
			<div class="page-header">
				<div class="row">
					<div class="col-md-9">
						<h1 class="page-title">{{ $t('Slider Banner') }}</h1>
						<div>Atur slider banner untuk ditampilkan di halaman depan Supplier</div>
					</div>
					<div class="col-md-3">
						<!-- <div class="page-header-right text-right">
							<button class="btn btn-primary" @click="showCreateForm = true">Add Banner</button>
						</div> -->
					</div>
				</div>
			</div>
			<div class="page-header">
				<div class="row">
					<div class="col-md-9">
                        <div class="row ml-1">
							<div class="col-md-6 p-0 m-0">
								<multiselect v-model="selectedSupplier"
									:show-labels="false"
									track-by="_id"
									label="label"
									placeholder="Search Supplier: email/name"
									:options=optionSupplier
									:loading="isSearchingSupplier"
									@search-change="fetchDataSupplier"
									>
									<span slot="noResult">
										No options matching the query
									</span>
									<span slot="noOptions">
										No options available
									</span>
								</multiselect>
							</div>
						</div>
					</div>
					<div class="col-md-3">
						<div class="page-header-right text-right">
							<button :disabled="selectedSupplier == null || isLimit" v-tooltip="{ content: isLimit ? 'Banners has reached limit' : '' }" class="btn btn-primary" @click="showCreateForm = true">Add Banner</button>
						</div>
					</div>
				</div>
			</div>

			<div class="page-content">
				<!-- Create Banner -->
				<div class="card card-body card-banner-container mb-4" v-if="showCreateForm">
					<div class="d-flex card-banner-header">
						<button class="btn btn-sm btn-plain">
							<i class="bi-plus-circle"></i>
						</button>
						<span class="banner-title align-self-center mr-auto">
							Buat Banner Baru
						</span>
						<!-- <button class="btn btn-sm btn-plain drag-item" v-tooltip="'Click to expand'" data-toggle="collapse" :data-target="`#section${banner._id}`" aria-expanded="false" :aria-controls="`section${banner._id}`">
							<i class="bi-chevron-down"></i>
						</button> -->
					</div>
					<div class="mt-2 p-3">
						<div class="form-group">
							<label for="title">Judul Banner</label>
							<input type="text" class="form-control" v-model="title" id="title" placeholder="Judul banner" required>
						</div>
						<div class="form-group">
							<label for="url">Link To</label>
							<input type="text" class="form-control" v-model="url" id="url" placeholder="Input url for banner" required>
						</div>
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label for="image">Upload Banner Promosi Desktop</label>
									<button class="btn btn-sm btn-plain text-danger" v-if="previewImage !== ''" @click="previewImage = ''">
										<i class="bi-x-circle"></i> Remove Image
									</button>
									<div class="my-2 text-center preview-image" v-if="previewImage !== ''">
										<img class="img-fluid rounded" :src="previewImage" alt="Uploaded Image">
									</div>
									<div
										v-if="isUploading && previewImage === ''"
										class="pc-image-empty"
									>
										<div class="image-loading">
											<div class="is-loading"></div>
										</div>
									</div>
									<div
										v-else-if="previewImage === ''"
										class="pc-image-empty cursor-pointer"
										@click="uploadImage('desktop_image')"
									>
										<div class="image-upload-placeholder">
											<i class="fi fi-rr-picture image-placeholder"></i>
											<div class="text-placeholder">
												Klik untuk upload.
											</div>
										</div>
									</div>
									<div class="pc-input-desc">
										Upload image dengan resolusi 1296x324px agar fit dengan ukuran banner.
									</div>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label for="image">Upload Banner Promosi Mobile (optional)</label>
									<button class="btn btn-sm btn-plain text-danger" v-if="previewImageMobile !== ''" @click="previewImageMobile = ''">
										<i class="bi-x-circle"></i> Remove Image
									</button>
									<div class="my-2 text-center preview-image" v-if="previewImageMobile !== ''">
										<img class="img-fluid rounded" :src="previewImageMobile" alt="Uploaded Image">
									</div>
									<div
										v-if="isUploadingMobile && previewImageMobile === ''"
										class="pc-image-empty"
									>
										<div class="image-loading">
											<div class="is-loading"></div>
										</div>
									</div>
									<div
										v-else-if="previewImageMobile === ''"
										class="pc-image-empty cursor-pointer"
										@click="uploadImage('mobile_image')"
									>
										<div class="image-upload-placeholder">
											<i class="fi fi-rr-picture image-placeholder"></i>
											<div class="text-placeholder">
												Klik untuk upload.
											</div>
										</div>
									</div>
									<div class="pc-input-desc">
										Upload image dengan resolusi 1518x759px agar fit dengan ukuran banner.
									</div>
								</div>
							</div>
						</div>
						<div class="form-group buttons m-0 hidden">
							<input
								type="file"
								accept="image/*"
								class="input-file"
								ref="imageUploader"
								id="pc-product-images-file"
								@change="onInputImageChange"
								multiple
							/>
							<label
								for="pc-product-images-file"
								class="btn btn-primary"
								:class="{ 'is-loading': isFetching }"
								>Upload images</label
							>
							<div class="pc-input-desc">
								Make sure your image resolution is 1296x324 px
							</div>
						</div>
						<div class="mt-3 pull-right">
							<button type="button" class="btn-outline o-md outline-primary mr-2" @click="showCreateForm = false">Cancel</button>
							<button type="button" class="btn-outline o-md outline-primary active" @click="createBanner">Submit</button>
						</div>
					</div>
				</div>

				<!-- List -->
				<div class="row" v-if="isFetching">
					<shimmer
						class="mt-3"
						width="100%"
						height="100px"
					/>
					<shimmer
						class="mt-3"
						width="100%"
						height="100px"
					/>
					<shimmer
						class="mt-3"
						width="100%"
						height="100px"
					/>
					<shimmer
						class="mt-3"
						width="100%"
						height="100px"
					/>
					<shimmer
						class="mt-3"
						width="100%"
						height="100px"
					/>
				</div>
				<template v-if="banners.length > 0 && !isFetching">
					<draggable
						v-model="banners"
						group="people"
						@start="drag=true"
						@end="onDraggedEnd"
						handle=".drag-item"
					>
						<div class="card card-body card-banner-container mb-4" v-for="banner in banners" :key="banner._id">
							<div class="d-flex card-banner-header">
								<button class="btn btn-sm btn-plain drag-item" v-tooltip="'Drag to order'">
									<i class="bi-grip-vertical"></i>
								</button>
								<span class="banner-title align-self-center mr-auto">
									{{ banner.data.title }}
								</span>
								<button class="btn btn-sm btn-plain" v-tooltip="'Remove this banner'" @click="showRemoveModal(banner._id)">
									<i class="bi-x-lg"></i>
								</button>
								<button class="btn btn-sm btn-plain drag-item" v-tooltip="'Click to expand'" data-toggle="collapse" :data-target="`#section${banner._id}`" aria-expanded="false" :aria-controls="`section${banner._id}`">
									<i class="bi-chevron-down"></i>
								</button>
							</div>
							<div class="collapse" :id="`section${banner._id}`">
								<div class="card-body">
									<div>
										<label>Banner Promosi Desktop</label>
										<div class="text-center my-2">
											<img class="img-fluid rounded" :src="banner.data.image" alt="">
										</div>
									</div>
									<div v-if="banner.data.image_mobile">
										<label>Banner Promosi Mobile</label>
										<div class="text-center my-2">
											<img class="img-fluid rounded" :src="banner.data.image_mobile" alt="">
										</div>
									</div>
									<strong>Link to : {{ banner.data.url }}</strong>
								</div>
							</div>
						</div>
					</draggable>
				</template>
				<template v-if="banners.length < 1 && !isFetching">
					<div class="list-empty table-empty">
						<i class="material-icons mr-2 va-m">error_outline</i>
						<span class="va-m" v-if="selectedSupplier !== null">{{ $t('No banner was found') }}</span>
						<span class="va-m" v-else>{{ $t('Select Supplier First') }}</span>
					</div>
				</template>

				<!-- debug : for dev only -->
				<!-- <hr>
				<div>
					{{ banners }}
				</div> -->
			</div>
		</div>

		<notifications group="admin-sliders" position="bottom right" />
		<!-- Modal Change Status -->
		<modal
			class="table-change-status-modal"
			size="medium"
			@close="isConfirmDelete = false"
			v-if="isConfirmDelete">
			<div slot="header">
				<h3>Confirm Status</h3>
			</div>
			<div slot="body">
				<div class="text-left">
					Are you sure want to remove this banner ?
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isConfirmDelete = false">{{ $t('Close') }}</button>
				<button type="button" class="btn btn-danger" @click="removeBanner(selectedBannerId)">Remove</button>
			</div>
		</modal>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import mediaApi from '@/api/media';
import adminApi from '@/api/admin';
import Modal from '@/components/Modal.vue';
import Shimmer from '@/components/Shimmer.vue';
import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'AdminSliderSupplier',
	components: {
		draggable,
		Shimmer,
		Modal,
	},
	data() {
		return {
			keyword: '',
			limit: 20,
			page: 1,
			sort_by: 'created_at',
			sort: 'desc',
			isFetching: false,
			isSaveChange: false,
			params: [],
			currentApprovalTime: '',
			productApprovalTime: '',
			banners: [],
			showCreateForm: false,
			title: '',
			image: '',
			imageMobile: '',
			url: '',
			previewImage: '',
			previewImageMobile: '',
			isUploading: false,
			isUploadingMobile: false,
			stateUpload: 'desktop_image',
			optionSupplier: [],
			selectedSupplier: null,
			isSearchingSupplier: false,
			selectedBannerId: null,
			isConfirmDelete: false,
		};
	},
	methods: {
		...mapActions({}),
		showRemoveModal(id) {
			this.isConfirmDelete = true;
			this.selectedBannerId = id;
		},
		fetchBanners() {
			this.isFetching = true;

			const params = {};

			if (this.selectedSupplier) {
				params.supplier_id = this.selectedSupplier._id;
			}

			const callback = (response) => {
				const banners = response.data;
				this.banners = banners;
				this.isFetching = false;
				this.isSearchingSupplier = false;
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			adminApi.listSupplierBanner(params, callback, errorCallback);
		},
		uploadImage(state) {
			console.log('up');
			this.stateUpload = state;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		onInputImageChange(event) {
			if (this.stateUpload === 'desktop_image') {
				this.image = '';
				this.previewImage = '';
				this.isUploading = true;
			} else if (this.stateUpload === 'mobile_image') {
				this.imageMobile = '';
				this.previewImageMobile = '';
				this.isUploadingMobile = true;
			}
			const maxUploadSize = 3; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 3MB)`;
					this.$notify({
						group: 'admin-sliders',
						text: noticeMessage,
						type: 'warn',
					});
					this.isUploading = false;
					this.isUploadingMobile = false;
					break;
				}

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('image', image);

				const callback = (response) => {
					this.isUploading = false;
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;

					if (this.stateUpload === 'desktop_image') {
						this.image = url;
						this.previewImage = url;
						this.isUploading = false;
					} else if (this.stateUpload === 'mobile_image') {
						this.imageMobile = url;
						this.previewImageMobile = url;
						this.isUploadingMobile = false;
					}
				};

				const errorCallback = (e) => {
					this.isUploading = false;
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
		createBanner() {
			if (this.title === '' || this.image === '' || this.url === '') {
				this.$notify({
					group: 'admin-sliders',
					title: 'Create Banner',
					text: 'Semua inputan harus diisi.',
					type: 'error',
				});
			} else {
				this.isFetching = true;
				const params = {
					title: this.title,
					image: this.image,
					image_mobile: this.imageMobile,
					url: this.url,
					supplier_id: this.selectedSupplier._id,
				};

				const callback = (response) => {
					// const banners = response.data;
					const message = response.message;
					this.$notify({
						group: 'admin-sliders',
						title: 'Create Banner',
						text: message,
						type: response.http_code === 400 ? 'error' : 'success',
					});
					this.fetchBanners();
					this.title = '';
					this.image = '';
					this.imageMobile = '';
					this.url = '';
					this.previewImage = '';
					this.previewImageMobile = '';
					this.isFetching = false;
					this.showCreateForm = false;
				};

				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'admin-sliders',
						title: 'Create Banner',
						text: message,
						type: 'error',
					});
					this.isFetching = false;
				};

				adminApi.createBanner(params, callback, errorCallback);
			}
		},
		removeBanner(id) {
			this.isFetching = true;

			const callback = (response) => {
				// const banners = response.data;
				const message = response.message;
				this.$notify({
					group: 'admin-sliders',
					title: 'Delete Banner',
					text: message,
					type: 'success',
				});
				this.fetchBanners();
				this.isFetching = false;
				this.isConfirmDelete = false;
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'admin-sliders',
					title: 'Delete Banner',
					text: message,
					type: 'error',
				});
				this.isFetching = false;
			};

			adminApi.deleteBanner(id, callback, errorCallback);
		},
		fetchDataSupplier(query) {
			this.isSearchingSupplier = true;

			const params = {
				keyword: query,
				role: 'owner',
				owner_type: 'supplier',
			};

			const callback = (response) => {
				this.optionSupplier = response.data;
				this.isSearchingSupplier = false;
			};
			const errorCallback = () => {
				this.isSearchingSupplier = false;
			};

			this.ooDelay(() => {
				if (query !== '') {
					adminApi.searchUser(params, callback, errorCallback);
				}
			}, 1000);
		},
		onDraggedEnd() {
			this.drag = false;
			const params = {
				banners: JSON.stringify(this.banners),
			};

			const callback = () => {
				this.fetchBanners();
			};
			const errorCallback = () => {
				this.$notify({
					group: 'app',
					title: 'Supplier Banner',
					text: 'Failed to Change Order',
					type: 'error',
				});
			};

			adminApi.changeOrderBanner(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({}),
		isLimit() {
			return this.banners.length >= 5;
		},
	},
	created() {
		// this.fetchBanners();
	},
	watch: {
		selectedSupplier() {
			if (this.selectedSupplier) {
				this.fetchBanners();
			}
		},
	},
};
</script>
<style lang="scss" scoped>
	.card-banner-container {
		border: 2px solid #4D4D4D;
		border-radius: 10px;

		// .card-banner-header {
		// 	border-bottom: 2px solid #ADB5BD;
		// 	padding-bottom: 20px;
		// }

		.banner-title {
			font-weight: 700;
			font-size: 22px;
			line-height: 120%;
		}

		.drag-item {
			font-weight: 700;
			font-size: 16px;
		}

		label {
			font-weight: 700;
			font-size: 16px;
			line-height: 150%;
		}

		.form-control {
			border: 2px solid #1F1F1F61;
			height: calc(2.3em + 0.75rem + 2px);
		}
	}
</style>
